import { Grid, Paper, TableCell, TableRow } from "@material-ui/core";
import {
  InputCheckboxMaster,
  InputTextMaster,
  MasterButton,
  ModalExportList,
  TableWrapper,
} from "App/Component/ui";
import { BASE_URL_4, instance4, STYLE_DEFAULT_MASTER } from "App/constants";
import { useDatatables } from "App/hooks";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import React, { useEffect, useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  isNull,
} from "App/utils/helpers";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import ModalImport from "./ModalImport";
export const InventoryButtonAction = ({
  handleClickAdd,
  handleClikReset,
  isExport = false,
  formFilter = [],
  urlExport = "",
  titelExportModal = "List Export",
  type = "",
  handleSubmit,
  withImport = false,
  setNewDataImport,
}) => {
  const [showModalExportList, setShowModalExportList] = useState(false);
  const [showModalImport, setShowModalImport] = useState(false);
  // const [rowsExport, setRowsExport] = useState([]);
  // const [readyExport, setReadyExport] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const csvLink = useRef(null);

  const getExport = async (formFilter) => {
    try {
      const api = await instance4.post(urlExport, {
        nama_barang: formFilter.barang_name,
        gudang_id: formFilter.gudang_id,
      });
      const res = api.data;
      if (res.status === 200) {
        return {
          state: true,
          message: res.message,
        };
      } else {
        return {
          state: false,
          message: res.message,
        };
      }
    } catch (error) {
      console.log(error);
      return {
        state: false,
        message: error?.response?.data?.message,
      };
    }
  };

  const handleExportAll = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const res = await getExport(formFilter);
    if (res.state) {
      defaultToastSuccess("Berhasil, mohon menunggu data sedang dieksport...");
    } else {
      defaultToastError(res.message);
    }
    setIsLoading(false);
  };

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      <MasterButton
        name={"RESET"}
        outline={true}
        color={"danger"}
        type={"button"}
        size={"md"}
        onClick={handleClikReset}
      />

      <div
        style={{
          display: "flex",
          gap: "10px",
        }}
      >
        {withImport && (
          <>
            <MasterButton
              type={"button"}
              color={isNull(formFilter.gudang_id) ? "secondary" : "warning"}
              name={"Import Pembaharuan"}
              size="md"
              disabled={isNull(formFilter.gudang_id) ? true : false}
              onClick={() => setShowModalImport(!showModalImport)}
            />
          </>
        )}
        {isExport && (
          <>
            <MasterButton
              type={"button"}
              color="primary-cyan"
              name={"Export List"}
              size="md"
              onClick={() => setShowModalExportList(!showModalExportList)}
            />
            <MasterButton
              type={"button"}
              color="danger"
              name={isLoading ? "Loading..." : "EXPORT CSV"}
              disabled={isLoading}
              size="md"
              onClick={handleExportAll}
            />
          </>
        )}

        <MasterButton
          name={"TAMBAH"}
          outline={true}
          color={"warning"}
          onClick={handleClickAdd}
          type={"button"}
          size={"md"}
        />
        <MasterButton
          name={"CARI"}
          outline={true}
          color={"green"}
          type={"button"}
          size={"md"}
          onClick={handleSubmit}
        />
      </div>
      {showModalExportList && (
        <ModalExportList
          title={titelExportModal}
          showModal={() => setShowModalExportList(false)}
          type={type}
          service={BASE_URL_4}
        />
      )}
      {showModalImport && (
        <ModalImport
          setShowModal={() => setShowModalImport(false)}
          setNewData={setNewDataImport}
        />
      )}
    </Grid>
  );
};

export const InventoryKelolaDisplayBarang = ({
  idGudang,
  namaGudang,
  rowsBarang,
  callback,
}) => {
  const classes = STYLE_DEFAULT_MASTER();
  return (
    <>
      <div
        className={`${classes.root} show-element`}
        style={{
          marginBottom: "1rem",
        }}
      >
        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}
        >
          <InputTextMaster
            type="text"
            disabled={true}
            name="namaGudang"
            id="namaGudang"
            readOnly={true}
            value={namaGudang}
          />

          <InventoryDaftarBarang rows={rowsBarang} callback={callback} />
        </Paper>
      </div>
    </>
  );
};

export const InventoryDaftarBarang = ({ rows, callback }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  const [rowsSelect, setRowsSelect] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClickSingleSelect = (row) => {
    const filter = rowsSelect.filter((item) => item === row.id);
    if (filter.length > 0) {
      const filterExcept = rowsSelect.filter((item) => item !== row.id);
      setRowsSelect(filterExcept);
    } else {
      setRowsSelect([...rowsSelect, row.id]);
    }
  };

  const handleClickAllSelect = () => {
    const all = stableSort(data, getComparator(order, orderBy)).slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );

    const _temp = [];
    all.map((item) => _temp.push(item.id));
    setRowsSelect(_temp);
  };

  const checkAlready = (id) => {
    const filter = rowsSelect.filter((item) => item === id);
    return filter.length > 0 ? true : false;
  };

  const handleClickReset = () => {
    setRowsSelect([]);
  };

  const handleClickSimpan = async () => {
    setLoading(true);
    const response = await callback(rowsSelect);
    if (response.state) {
      defaultToastSuccess(response.message);
      setLoading(false);
    } else {
      defaultToastError(response.message);
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        marginTop: "1rem",
      }}
    >
      <TableWrapper
        title="Daftar Barang Yang Belum Ada"
        setQ={setQ}
        withAddButton={false}
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                onClick={() => handleClickSingleSelect(row)}
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  width={"5%"}
                  align="center"
                >
                  {index + 1}
                </TableCell>

                <TableCell
                  component="th"
                  scope="row"
                  width={"5%"}
                  padding="none"
                >
                  <InputCheckboxMaster
                    name="status"
                    defaultChecked={checkAlready(row.id)}
                    id="status"
                    label=""
                    // onChange={() => handleClickSingleSelect(row)}
                  />
                </TableCell>

                <TableCell align="left">
                  {row?.id}
                </TableCell>
                <TableCell align="left" width={"80%"}>
                  {row?.name}
                </TableCell>
              </TableRow>
            );
          })}
      </TableWrapper>

      <div
        className="mt-2"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
        }}
      >
        <MasterButton
          color="danger"
          type="button"
          name="RESET"
          onClick={handleClickReset}
          size="xl"
          style={{
            padding: "0.5rem 1rem",
            textAlign: "center",
          }}
        />
        <MasterButton
          color="primary-cyan"
          type="button"
          name="SELECT PER PAGE"
          size="xl"
          onClick={handleClickAllSelect}
          style={{
            padding: "0.5rem 1rem",
            textAlign: "center",
          }}
        />

        <MasterButton
          color={loading ? "secondary" : "green"}
          type="button"
          name={loading ? "Loading.." : "SIMPAN"}
          disabled={loading}
          onClick={handleClickSimpan}
          size="xl"
          style={{
            padding: "0.5rem 1rem",
            textAlign: "center",
          }}
        />
      </div>
    </div>
  );
};

const getBarangByGudangId = async (
  idGudang,
  urlBarangGudang = LIST_URL_WAREHOUSE.daftarInventoryControl.barangNotinGudang
) => {
  try {
    const response = await instance4.get(`${urlBarangGudang}/${idGudang}`);
    if (response.data.status === 200) {
      return {
        state: true,
        data: response.data.body,
      };
    } else {
      return {
        state: false,
        message: response.data.message,
        data: [],
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
      data: [],
    };
  }
};

export const addBulkBarang = async (
  idGudang,
  idBarang,
  urlBulk = "/wmsfarmasi/inventory/bulk-register"
) => {
  try {
    const response = await instance4.post(urlBulk, {
      id_gudang: idGudang,
      id_barang: idBarang,
    });

    if (response.data.status === 200) {
      return {
        state: true,
        message: "Berhasil menambah barang",
      };
    } else {
      return {
        state: false,
        message: response.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const useGetInventoryBarang = (idGudang, reload, urlBarangGudang) => {
  const [rows, setRows] = useState([]);

  const setNewData = async () => {
    const response = await getBarangByGudangId(idGudang, urlBarangGudang);
    if (response.state) {
      setRows(response.data);
    } else {
      setRows([]);
    }
  };

  useEffect(() => {
    if (!isNull(idGudang)) {
      setNewData();
    }
  }, [idGudang, reload]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    listBarang: rows,
  };
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "kode",
    disablePadding: false,
    label: "ID BARANG",
    align: "left",
    minWidth: "80px",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "200px",
  },
];
